import { DEFAULT_FEDERAL_CONTRACT_FILTER } from '@/constants/search/federal/contract'
import { DEFAULT_DIBBS_FILTER } from '@/constants/search/federal/dibbs'
import { DEFAULT_FEDERAL_GRANT_FILTER } from '@/constants/search/federal/grant'
import { DEFAULT_SBIR_FILTER } from '@/constants/search/federal/sbir'
import { DEFAULT_SLED_CONTRACT_FILTER } from '@/constants/search/sled/contract'

import type { DibbsContractSearchFilter } from '@/types/dibbs/Dibbs'
import type { FederalContractSearchFilter } from '@/types/federal-contract/Filter'
import type { FederalGrantSearchFilter } from '@/types/federal-grant/Filter'
import type { SbirSearchFilter } from '@/types/sbir/Filter'
import type { SledContractSearchFilter } from '@/types/sled-contract/Filter'

export const calcNumDiffDibbsContractSearchFilter = (
  target: DibbsContractSearchFilter,
  source: DibbsContractSearchFilter = DEFAULT_DIBBS_FILTER,
): number => {
  let diff: number = 0
  if (
    target.active_after !== source.active_after ||
    target.active_before !== source.active_before
  ) {
    diff += 1
  }
  if (
    target.published_after !== source.published_after ||
    target.published_before !== source.published_before
  ) {
    diff += 1
  }
  if (target.is_active !== undefined && target.is_active !== null) {
    diff += 1
  }
  diff += Math.abs(target.nsn_numbers.length - source.nsn_numbers.length)
  diff += Math.abs(target.psc_codes.length - source.psc_codes.length)
  diff += Math.abs(target.cage_codes.length - source.cage_codes.length)
  diff += Math.abs(target.part_numbers.length - source.part_numbers.length)
  diff += Math.abs(
    target.set_aside_codes.length - source.set_aside_codes.length,
  )
  return diff
}

export const calcNumDiffFederalContractSearchFilter = (
  target: FederalContractSearchFilter,
  source: FederalContractSearchFilter = DEFAULT_FEDERAL_CONTRACT_FILTER,
): number => {
  let diff: number = 0
  if (
    target.active_after !== source.active_after ||
    target.active_before !== source.active_before
  ) {
    diff += 1
  }
  if (
    target.published_after !== source.published_after ||
    target.published_before !== source.published_before
  ) {
    diff += 1
  }
  if (target.is_active !== undefined && target.is_active !== null) {
    diff += 1
  }
  diff += Math.abs(target.buyer_ids.length - source.buyer_ids.length)
  diff += Math.abs(target.naics_codes.length - source.naics_codes.length)
  diff += Math.abs(target.psc_codes.length - source.psc_codes.length)
  diff += Math.abs(
    target.set_aside_codes.length - source.set_aside_codes.length,
  )
  diff += Math.abs(target.notice_types.length - source.notice_types.length)
  diff += Math.abs(
    target.solicitation_numbers.length - source.solicitation_numbers.length,
  )
  return diff
}

export const calcNumDiffFederalGrantSearchFilter = (
  target: FederalGrantSearchFilter,
  source: FederalGrantSearchFilter = DEFAULT_FEDERAL_GRANT_FILTER,
): number => {
  let diff: number = 0
  if (
    target.active_after !== source.active_after ||
    target.active_before !== source.active_before
  ) {
    diff += 1
  }
  if (
    target.published_after !== source.published_after ||
    target.published_before !== source.published_before
  ) {
    diff += 1
  }
  if (target.is_active !== undefined && target.is_active !== null) {
    diff += 1
  }
  diff += Math.abs(target.agencies.length - source.agencies.length)
  diff += Math.abs(target.statuses.length - source.statuses.length)
  diff += Math.abs(
    target.eligible_applicants.length - source.eligible_applicants.length,
  )
  diff += Math.abs(
    target.funding_instruments.length - source.funding_instruments.length,
  )
  diff += Math.abs(
    target.funding_categories.length - source.funding_categories.length,
  )
  diff += Math.abs(
    target.opportunity_categories.length - source.opportunity_categories.length,
  )
  return diff
}

export const calcNumDiffSbirSearchFilter = (
  target: SbirSearchFilter,
  source: SbirSearchFilter = DEFAULT_SBIR_FILTER,
): number => {
  let diff: number = 0
  if (
    target.active_after !== source.active_after ||
    target.active_before !== source.active_before
  ) {
    diff += 1
  }
  if (
    target.published_after !== source.published_after ||
    target.published_before !== source.published_before
  ) {
    diff += 1
  }
  if (target.is_active !== undefined && target.is_active !== null) {
    diff += 1
  }
  diff += Math.abs(target.numbers.length - source.numbers.length)
  diff += Math.abs(target.programs.length - source.programs.length)
  diff += Math.abs(target.phases.length - source.phases.length)
  diff += Math.abs(target.agencies.length - source.agencies.length)
  diff += Math.abs(target.branches.length - source.branches.length)
  diff += Math.abs(
    target.current_statuses.length - source.current_statuses.length,
  )
  diff += Math.abs(target.topic_branches.length - source.topic_branches.length)
  diff += Math.abs(target.topic_numbers.length - source.topic_numbers.length)
  return diff
}

export const calcNumDiffSledContractSearchFilter = (
  target: SledContractSearchFilter,
  source: SledContractSearchFilter = DEFAULT_SLED_CONTRACT_FILTER,
): number => {
  let diff: number = 0
  if (
    target.active_after !== source.active_after ||
    target.active_before !== source.active_before
  ) {
    diff += 1
  }
  if (
    target.published_after !== source.published_after ||
    target.published_before !== source.published_before
  ) {
    diff += 1
  }
  if (target.is_active !== undefined && target.is_active !== null) {
    diff += 1
  }
  diff += Math.abs(
    target.jurisdiction_ids.length - source.jurisdiction_ids.length,
  )
  diff += Math.abs(target.nigp_codes.length - source.nigp_codes.length)
  diff += Math.abs(target.unspsc_codes.length - source.unspsc_codes.length)
  return diff
}
